import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import SectorGroupForm from "./sectorGroupForm";

const SectorGroupModal = ({ toggle, isOpen, groupInfo, reload }) => {
  return (
    <div>
      <Modal isOpen={isOpen} centered>
        <ModalHeader toggle={toggle} className="d-flex justify-content-center border-0 pb-1" />
        <ModalBody>
          <SectorGroupForm toggle={toggle} groupInfo={groupInfo} reload={reload} />
        </ModalBody>
      </Modal>
    </div>
  );
};

export default SectorGroupModal;
